import Flex from 'typescript-styled-flex'
import styled from '../../../theme'

const Tags = styled(Flex as any)`
  flex-wrap: wrap;
  align-items: center;
`

export default Tags
